"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (error) => (Object.assign({ unknown: true }, (error ? { error } : {})));
//# sourceMappingURL=unknown.js.map